import { Typography } from '@mui/material';
import clsx from 'clsx';
import { JoveFormTitleDirectionEnum } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
export var getFormTitleComponent = function getFormTitleComponent(config) {
  var formTitleSlot = config.formTitleSlot,
      formTitle = config.formTitle,
      formTitleDirection = config.formTitleDirection,
      formTitleClassName = config.formTitleClassName,
      disabled = config.disabled;
  return formTitleSlot ? formTitleSlot : !!formTitle ? /*#__PURE__*/_jsx(Typography, {
    variant: "subtitle2",
    className: clsx('font-bold', formTitleClassName, formTitleDirection === JoveFormTitleDirectionEnum.top ? 'mb-1' : ''),
    style: {
      color: disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
    },
    children: formTitle
  }) : null;
};